import { ReactLenis } from 'lenis/react'
import { type PropsWithChildren, useState, useEffect } from 'react'

// Lenis hijacks the scroll event to add inertia/easing -- a real motion
// effect that prefers-reduced-motion's CSS-only guard (src/index.css)
// doesn't touch, since that only disables CSS animations/transitions.
// Checked separately here so a reduced-motion visitor gets plain native
// scroll instead.
export function SmoothScroll({ children }: PropsWithChildren) {
  const [allowMotion, setAllowMotion] = useState(true)

  useEffect(() => {
    const query = window.matchMedia('(prefers-reduced-motion: reduce)')
    setAllowMotion(!query.matches)
    const onChange = () => setAllowMotion(!query.matches)
    query.addEventListener('change', onChange)
    return () => query.removeEventListener('change', onChange)
  }, [])

  if (!allowMotion) return children

  return (
    <ReactLenis root options={{ lerp: 0.1, duration: 1.2 }}>
      {children}
    </ReactLenis>
  )
}
